import { makeStyles } from '@material-ui/core'
import { OpenSolarThemeType } from 'Themes'
import { authSelectors } from 'ducks/auth'
import CustomField from 'elements/field/CustomField'
import { Box, styled, Typography } from 'opensolar-ui'
import AccordionCard from 'projectSections/sections/info/AccordionCard'
import { useTranslate } from 'ra-core'
import React from 'react'
import { SelectInput } from 'react-admin'
import { useSelector } from 'react-redux'
import DocusignSettingsSection from 'resources/contracts/DocusignSettingsSection'
import { useFeatureFlag } from 'util/featureFlags'

interface FieldTypes {
  disabled: boolean
}

const Row = styled(Box)({
  display: 'flex',
  alignItems: 'center',
})

export const IntegrationField: React.FC<FieldTypes> = ({ disabled }) => {
  const translate = useTranslate()
  const docusign_account_connected = useSelector(authSelectors.getDocusignAccountConnected)
  const pandadoc_account_connected = useSelector(authSelectors.getPandadocAccountConnected)
  const enablePandadoc = useFeatureFlag('pandadoc_integration', 'on')

  const showPandadoc = pandadoc_account_connected && enablePandadoc

  if (!docusign_account_connected && !showPandadoc) return null

  const choices = [{ id: 0, name: 'None' }]
  if (docusign_account_connected) {
    choices.push({ id: 1, name: 'DocuSign' })
  }
  if (showPandadoc) {
    choices.push({ id: 2, name: 'PandaDoc' })
  }

  return (
    <Row>
      <Typography textVariant="body1" style={{ minWidth: 100, maxWidth: 100, marginRight: 10 }}>
        {translate('Integration')}
      </Typography>
      <CustomField
        component={SelectInput}
        fullWidth={true}
        multiline={true}
        style={{ width: '256px' }}
        choices={choices}
        name="integration"
        source="integration"
        label={false}
        disabled={disabled}
      />
    </Row>
  )
}

export const useStyles = makeStyles((theme: OpenSolarThemeType) => ({
  accordion: {
    marginTop: '20px !important',
    '& .MuiAccordionDetails-root': {
      padding: '0px 30px 20px',
    },
  },
}))

interface PropTypes {
  disabled: boolean
}

const DocusignSettings: React.FC<PropTypes> = ({ disabled }) => {
  const classes = useStyles()
  const translate = useTranslate()
  return (
    <AccordionCard
      className={classes.accordion}
      title={translate('DocuSign Settings')}
      name={'docusign-settings'}
      disabled={disabled}
      content={DocusignSettingsSection}
      titleIcon={() => <></>}
      lazyRender={true}
    />
  )
}
export default DocusignSettings
